/* ==========================================================================
   BOUNTEOUS CONFIDENTIAL
   ___________________

   Copyright 2019 Bounteous
   All Rights Reserved.

   NOTICE:  All information contained herein is, and remains the property
   of Bounteous and its suppliers, if any. The intellectual and
   technical concepts contained herein are proprietary to Bounteous
   and its suppliers and are protected by trade secret or copyright law.
   Dissemination of this information or reproduction of this material
   is strictly forbidden unless prior written permission is obtained
   from Bounteous.
   ========================================================================== */

export const BREAKPOINTS = {
    SMALL_MOBILE: 479,
    MOBILE: 767,
    TABLET: 1024,
    SMALL_DESKTOP: 1279,
};

export const ROCKWELL_BREAKPOINTS_MAX = {
    XLDESKTOP: 1280,
    DESKTOP: 768
};

export const ROCKWELL_BREAKPOINTS_MAX_EM = {
    XLDESKTOP: 80, // @bp-xldesktop-min-em
    DESKTOP: 48 // @bp-desktop-min-em
};
